import { ValueContainerProps, components } from 'react-select'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSIcon from 'designSystem/components/PDSIcon/PDSIcon'
import { SIZE } from 'designSystem/foundations/constants/size'

const CustomValueContainer = ({ children, ...props }: ValueContainerProps) => {
  return (
    components.ValueContainer && (
      <components.ValueContainer {...props}>
        {!!children && (
          <PDSBox position="absolute" marginLeft={SIZE.s8}>
            <PDSIcon name="search" marginLeft={SIZE.s2} />
          </PDSBox>
        )}
        {children}
      </components.ValueContainer>
    )
  )
}

export default CustomValueContainer
